import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ImportantFieldData } from "@app2/search/search-shared/search-results-table.component";

@Component({
    selector: "important-fields-container",
    template: `
        <div class="important-fields-row" test-id="important-fields-row">
            <div *ngFor="let data of categorizedFieldData | keyvalue"
                 class="important-field-container"
                 [attr.test-id]="'important-field-container-' + data.key">
                <span class="important-field-label">
                    {{ data.key | localize }}
                </span>
                <ng-container *ngIf="data.value.size > 0; else noImportantFieldContainer">
                        <ds-dropdown class="important-field-selector"
                                 dropdownClass="important-field-cdk-pane"
                                 [showHeader]="false"
                                 [showFooter]="false"
                                 test-class="important-field-value-selector">
                        <div id="ds-dropdown-trigger" class="dropdown-value">
                            {{ data.value.size }}
                        </div>
                        <li *ngFor="let value of data.value"
                            class="remove-custom-styles click-target">
                            <div class="item-container">
                                <a class="no-underline"
                                   dsRouterLink="."
                                   target="_blank"
                                   [queryParams]="{ mode: 'alert_story', selected: value }"
                                   [matTooltip]="'GO_TO_STORY_VIEW' | localize"
                                   queryParamsHandling="merge">
                                    {{ value }}
                                </a>
                                <search-link [queryString]=addQuotes(value)
                                             [begin]="resultTimestamp"
                                             [end]="resultEndTimestamp"
                                             [defaultText]="false"
                                             [newTab]="true"
                                             [matTooltip]="'SEARCH_EVENTS' | localize">
                                    <i class="far fa-arrow-up-right-from-square primary"></i>
                                </search-link>
                            </div>
                        </li>
                    </ds-dropdown>
                </ng-container>
                <ng-template #noImportantFieldContainer>
                    <span class="no-important-field-value" test-id="no-important-field-value">—</span>
                </ng-template>
            </div>
        </div>
    `,
    styles: [`
        @import "/src/styles/colors";
        @import "/src/styles/settings";

        .important-fields-row {
            display: flex;
            margin-top: 12px;
        }

        .important-field-container {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            border: 1px solid $gray-5;
            border-radius: 2px;
            padding: 16px 24px;

            &:not(:last-child) {
                margin-right: 16px;
            }
        }

        .important-field-label {
            font-weight: $font-weight-demibold;
            line-height: 1rem;
        }

        .no-important-field-value {
            font-weight: $font-weight-demibold;
            color: $gray-6;
            font-size: 1.25rem;
            line-height: 1.5rem;
            margin-top: 8px;
        }

        .dropdown-value {
            font-size: 1.25rem;
            line-height: 1.5rem;
            margin-right: 2px;
        }

        .item-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 4px 0;

            search-link {
                margin-left: 24px;
            }
        }
    `],
})
export class ImportantFieldsContainerComponent implements OnChanges {
    @Input() importantFieldData: ImportantFieldData[];
    @Input() resultTimestamp: string;
    @Input() resultEndTimestamp: string;

    categorizedFieldData: Map<string, Set<string>> = new Map<string, Set<string>>(
        [
            ["IP_ADDRESS", new Set<string>()],
            ["USERNAME", new Set<string>()],
            ["DEVICE_INFO", new Set<string>()],
            ["EMAIL_ADDRESS", new Set<string>()],
            ["PHONE_NUMBER", new Set<string>()],
            ["ACCOUNT_NUMBER", new Set<string>()]
        ]
    );

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.importantFieldData && this.importantFieldData) {
            this.importantFieldData.forEach(data => {
                if (["ip_src", "client_ip"].includes(data.key)) {
                    data.value.forEach(val => this.categorizedFieldData.get("IP_ADDRESS").add(val));
                } else if (["user", "user_name", "finxact_id", "username"].includes(data.key)) {
                    data.value.forEach(val => this.categorizedFieldData.get("USERNAME").add(val));
                } else if (["user_agent", "browser"].includes(data.key)) {
                    data.value.forEach(val => this.categorizedFieldData.get("DEVICE_INFO").add(val));
                } else if (["email_address", "email_addresses", "action_taken_details"].includes(data.key)) {
                    data.value.forEach(val => this.categorizedFieldData.get("EMAIL_ADDRESS").add(val));
                } else if (["phone_number", "phone_numbers", "request_url"].includes(data.key)) {
                    data.value.forEach(val => this.categorizedFieldData.get("PHONE_NUMBER").add(val));
                } else {
                    data.value.forEach(val => this.categorizedFieldData.get("ACCOUNT_NUMBER").add(val));
                }
            });
            // add an end timestamp if not present, as queries break otherwise
            if (!this.resultEndTimestamp) {
                this.resultEndTimestamp = moment(this.resultTimestamp).add(1, "days").toISOString();
            }
        }
    }

    private addQuotes(input: string) : string {
        return "\"" + input + "\"";
    }
}
